const addToBaskets = document.querySelectorAll('.js-add-to-basket-form')

if (addToBaskets) {
  for(let i = 0; i < addToBaskets.length; i++) {
    const addToBasket = addToBaskets[i]
    new Vue({
      el: addToBasket,
      data() {
        return {
          dropdownOpen: 0,
          variant: {},
          text: {},
          amount: 1,
          modalOpen: 0,
          needsVariant: true,
          render: 0,
          flashNeed: false,
          outOfStock: 0,
        }
      },
      mounted() {
        document.querySelectorAll('.add-to-basket__select').forEach((select) => {
          if (select.querySelectorAll('option').length == 1) {
            const option = select.querySelectorAll('option')[0]
            this.select(
              parseInt(option.value),
              option.innerText,
              select.getAttribute('data-number')
            )
          }
        })
      },
      methods: {
        rerender() {
          this.render += 1
        },
        changeAmount(value) {
          const newAmount = parseInt(this.amount) + value
          if (newAmount > 0) {
            this.amount = newAmount
          }
        },
        handleSubmit(e) {
          if (this.needsVariant) {
            e.preventDefault();
            this.flashNeed = true
            setTimeout(() => {
              this.flashNeed = false
            }, 300)
          }
        },
        select(value, text, number, changePrice, changeBeforePrice, outOfStock) {
          if(outOfStock) {
            this.outOfStock = value;
          } else {
            this.outOfStock = 0;
          }

          if(changePrice) {
            const price = document.getElementById('js-product-price');
            if(price) {
              price.innerText = changePrice
            }
          }

          if(changeBeforePrice) {
            const beforePrice = document.getElementById('js-product-before-price');
            if(beforePrice) {
              beforePrice.innerText = changeBeforePrice
            }
          }

          this.variant[number.toString()] = value
          this.text[number.toString()] = text
          this.dropdownOpen = number

          this.rerender()

          setTimeout(() => {
            this.checkNeedsVariant()
          })
        },
        checkNeedsVariant() {
          let hasEmptyVariant = false
          document
            .querySelectorAll('.add-to-basket__select')
            .forEach((select) => {
              if (!select.value) {
                hasEmptyVariant = true
              }
            })

          this.needsVariant = hasEmptyVariant
        },
        toggleDropdown(number) {
          if (this.dropdownOpen == number) {
            this.dropdownOpen = 0
          } else {
            this.dropdownOpen = number
          }
        },
      },
    })
  }
}
